import MenuItem from "@mui/material/MenuItem";
import { AttendingEventType } from "store/attendingEvents/attendingEvents.types";
import styled from "styled-components";

export const LogoContainer = styled.div`
  width: 52px;
  height: 52px;
  border-radius: 12px;
  overflow: hidden;
  flex-shrink: 0;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.18);
  background: #ffffff;
`;

export const LogoImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
export const Sidebar = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1.75rem;
`;

export const Section = styled.section`
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  padding: 1.8rem 2rem;
  border: 1px solid #F3F4F6;
  transition: all 0.2s ease-in-out;
  
  &:hover {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }
`;

export const SectionTitle = styled.h3`
  margin: 0 0 0.9rem 0;
  font-size: 1.05rem;
  color: #fe2f67;
`;

export const RecommendCard = styled.div`
  display: flex;
  align-items: center;
  gap: 1.1rem;
  margin: 0.9rem 0;
`;

export const Logo = styled.span`
  font-size: 1.4rem;
`;

export const CompanyName = styled.span`
  flex: 1;
  font-weight: 600;
  font-size: 1rem;
`;

export const AddButton = styled.button`
  background: none;
  border: none;
  font-size: 1.3rem;
  color: #7d7d7d;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    font-size: 1.6rem;
  }
`;

export const ShowMoreLink = styled.a`
  display: block;
  margin-top: 1.8rem;
  text-align: center;
  font-size: 1.1rem;
  font-weight: 600;
  text-decoration: none;
  color: #fe2f67;
  cursor: pointer;
`;

export const ShowMoreButton = styled.button`
  background: none;
  border: none;
  display: block;
  margin-top: 1.8rem;
  text-align: center;
  font-size: 1.1rem;
  font-weight: 600;
  text-decoration: none;
  color: #fe2f67;
  cursor: pointer;
`;


